import { createSlice } from "@reduxjs/toolkit";
import { HomeState } from "./home.state";
import { getHomeSection } from "./home.thunk";
import { CollectionSection } from "./home.types";
import { toggleFollowCollection } from "../collection/collection.thunk";

const initialState: HomeState = {
  sections: {},
  status: {},
};

const homeSlice = createSlice({
  name: "home",
  initialState,
  reducers: {
    /**
     * Kimlikli section'ları at. Login/register sonrası çağrılıyor: önceki
     * kimliğe (veya misafire) ait kişiselleştirilmiş içerik ekranda kalmasın.
     * Logout'ta ayrıca rootReducer bu slice'ı komple sıfırlıyor.
     */
    clearHomeData: (state) => {
      state.sections = {};
      state.status = {};
    },
  },
  extraReducers: (build) => {
    build
      .addCase(getHomeSection.pending, (state, action) => {
        state.status[action.meta.arg] = "loading";
      })
      .addCase(getHomeSection.fulfilled, (state, action) => {
        state.sections[action.payload.slug] = action.payload.section;
        delete state.status[action.payload.slug];
      })
      .addCase(getHomeSection.rejected, (state, action) => {
        // Bilinçli sessiz: hata toast'lanmıyor. "error" işareti yalnızca
        // skeleton'ı kapatıp ISR'dan basılan anonim sürümü geri getirmek için.
        state.status[action.meta.arg] = "error";
      });

    // Reducer içinde fırlayan hata dispatch()'ten dışarı çıkar ve sayfayı
    // düşürür, o yüzden buradaki her erişim savunmalı: payload.data ve
    // collection section'ın items'ı API'den eksik gelebiliyor.
    build.addCase(toggleFollowCollection.fulfilled, (state, action) => {
      const isFollowed = action.payload?.data?.is_followed;
      if (isFollowed === undefined) return;

      const id = action.meta.arg;
      Object.values(state.sections).forEach((section) => {
        if (section.display_type !== "collection") return;
        const items = (section as unknown as CollectionSection).items;
        if (!Array.isArray(items)) return;
        items.forEach((col) => {
          if (col?.id === id) col.is_followed = isFollowed;
        });
      });
    });
  },
});

export const { clearHomeData } = homeSlice.actions;
export default homeSlice.reducer;
